import { useState } from "react";
import { episodeArcs } from "@/mocks/nanny";

export default function Episodes() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="episodes" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-5xl mx-auto">
          <div className="mb-10 md:mb-14">
            <span className="text-primary-300 font-label text-sm tracking-[0.2em] uppercase">Episodes</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-background-50">分集看点</h2>
            <p className="mt-3 text-background-300 text-sm md:text-base max-w-2xl leading-relaxed">
              以电视剧版全 36 集为参照，把故事分为四个阶段。点击任意阶段即可展开该段落的重点情节。
            </p>
          </div>

          <div className="space-y-3 md:space-y-4">
            {episodeArcs.map((arc, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={arc.range}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "bg-background-50/10 border-primary-400/60" : "bg-background-50/5 border-background-50/15"
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : i)}
                    className="w-full flex items-center gap-4 text-left px-4 md:px-6 py-4 md:py-5 cursor-pointer"
                  >
                    <span
                      className={`shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center font-heading font-semibold ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-50/10 text-background-200"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1">
                      <span className="block text-accent-300 text-xs md:text-sm font-label tracking-wide">{arc.range}</span>
                      <span className="block font-heading text-lg md:text-xl font-semibold text-background-50 mt-1">
                        {arc.title}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-2xl text-background-200 transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>

                  {isOpen && (
                    <div className="px-4 md:px-6 pb-5 md:pb-6 pl-16 md:pl-20">
                      <p className="text-background-300 text-sm md:text-base leading-relaxed">{arc.desc}</p>
                      <ul className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
                        {arc.points.map((p) => (
                          <li
                            key={p}
                            className="flex items-start gap-2 bg-background-50/10 rounded-md px-3 py-2.5 text-background-200 text-xs md:text-sm"
                          >
                            <i className="ri-play-list-2-line text-primary-300 mt-0.5"></i>
                            {p}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}